export default defineNuxtRouteMiddleware((to) => {});
